export default __webpack_public_path__ + "static/partner-tube-6-2a3758ff3d7b27ab2bbf09fc4ecf22fc.png";